var _path, _path2, _mask, _path3, _mask2, _path4, _mask3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JCB Card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.609 3.652A3.043 3.043 0 013.652.61h40.696a3.043 3.043 0 013.043 3.043v26.15a3.044 3.044 0 01-3.043 3.044H3.652A3.044 3.044 0 01.61 29.802V3.652z",
    fill: "#fff",
    stroke: "#E6E7E8",
    strokeWidth: 1.217
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.094 8.73c-.169 0-.337.006-.503.025a2.67 2.67 0 00-1.693.896 2.83 2.83 0 00-.645 1.32 3.793 3.793 0 00-.054.73v2.649c0 .062-.014.067.052.067h3.106c.34 0 .68-.013 1.019.019.333.031.672.13.941.341.379.298.533.813.403 1.286-.124.454-.496.758-.922.885a1.853 1.853 0 01-.143.036c-.028.006-.065.005-.09.017-.013.006-.045.014-.022.036.006.006.03.006.049.006h.017c.134.013.267.037.396.074.397.112.782.353.965.748a1.288 1.288 0 01-.244 1.41c-.277.285-.663.431-1.045.48-.192.024-.385.019-.577.019h-3.758c-.03 0-.113-.015-.137 0-.014.009-.01.022-.01.045v5.569c0 .01-.007.056 0 .064.009.01.078.001.095.001H32.048c.617 0 1.204-.165 1.704-.552a2.849 2.849 0 001.081-2.338v-.05V21.365v-1.342-1.647-1.818-1.882-1.814-1.618-2.186-.32H31.76c-.205 0-.413-.008-.62-.008h-.045zm-1.597 6.532c-.008.019 0 .061 0 .082v1.088c0 .03-.013.129.007.144.018.012.093 0 .116 0h.84c.157 0 .313.002.47 0a.722.722 0 00.519-.204.678.678 0 00.04-.877.677.677 0 00-.48-.244c-.089-.007-.178-.004-.267-.004h-1.198l-.027-.001c-.01 0-.014.003-.02.016zm1.023 2.188h-1.023v1.381c0 .022-.009.07 0 .091.014.032.141.014.182.014H30.964c.167 0 .328-.01.476-.102a.737.737 0 00.333-.523.777.777 0 00-.223-.673.73.73 0 00-.515-.188h-.515z",
    fill: "url(#jcb_paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 8,
    width: 7,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.094 8.73c-.169 0-.337.006-.503.025a2.67 2.67 0 00-1.693.896 2.83 2.83 0 00-.645 1.32 3.793 3.793 0 00-.054.73v2.649c0 .062-.014.067.052.067h3.106c.34 0 .68-.013 1.019.019.333.031.672.13.941.341.379.298.533.813.403 1.286-.124.454-.496.758-.922.885a1.853 1.853 0 01-.143.036c-.028.006-.065.005-.09.017-.013.006-.045.014-.022.036.006.006.03.006.049.006h.017c.134.013.267.037.396.074.397.112.782.353.965.748a1.288 1.288 0 01-.244 1.41c-.277.285-.663.431-1.045.48-.192.024-.385.019-.577.019h-3.758c-.03 0-.113-.015-.137 0-.014.009-.01.022-.01.045v5.569c0 .01-.007.056 0 .064.009.01.078.001.095.001H32.048c.617 0 1.204-.165 1.704-.552a2.849 2.849 0 001.081-2.338v-.05V21.365v-1.342-1.647-1.818-1.882-1.814-1.618-2.186-.32H31.76c-.205 0-.413-.008-.62-.008h-.045zm-1.597 6.532c-.008.019 0 .061 0 .082v1.088c0 .03-.013.129.007.144.018.012.093 0 .116 0h.84c.157 0 .313.002.47 0a.722.722 0 00.519-.204.678.678 0 00.04-.877.677.677 0 00-.48-.244c-.089-.007-.178-.004-.267-.004h-1.198l-.027-.001c-.01 0-.014.003-.02.016zm1.023 2.188h-1.023v1.381c0 .022-.009.07 0 .091.014.032.141.014.182.014H30.964c.167 0 .328-.01.476-.102a.737.737 0 00.333-.523.777.777 0 00-.223-.673.73.73 0 00-.515-.188h-.515z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.371 8.766a2.675 2.675 0 00-1.081.441 2.836 2.836 0 00-1.197 2.316V18.36c0 .051 0 .04.057.068l.19.09a5.557 5.557 0 001.6.475c.397.05.822.064 1.198-.099.301-.13.541-.37.665-.682.079-.2.102-.412.102-.627v-3.082c0-.017-.01-.07 0-.085.011-.018.104-.006.131-.006h2.208v3.221c0 .321-.046.643-.174.938a1.82 1.82 0 01-.586.731c-.614.459-1.427.578-2.17.613a10.76 10.76 0 01-1.591-.051 9.926 9.926 0 01-1.63-.285v5.818c0 .008-.005.048 0 .055.011.012.112 0 .132 0h3.136c.463 0 .937.033 1.39-.085a2.76 2.76 0 001.804-1.535c.188-.417.25-.86.25-1.312V8.729H15.983c-.205 0-.41.004-.613.037z",
    fill: "url(#jcb_paint1_linear)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 7,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.371 8.766a2.675 2.675 0 00-1.081.441 2.836 2.836 0 00-1.197 2.316V18.36c0 .051 0 .04.057.068l.19.09a5.557 5.557 0 001.6.475c.397.05.822.064 1.198-.099.301-.13.541-.37.665-.682.079-.2.102-.412.102-.627v-3.082c0-.017-.01-.07 0-.085.011-.018.104-.006.131-.006h2.208v3.221c0 .321-.046.643-.174.938a1.82 1.82 0 01-.586.731c-.614.459-1.427.578-2.17.613a10.76 10.76 0 01-1.591-.051 9.926 9.926 0 01-1.63-.285v5.818c0 .008-.005.048 0 .055.011.012.112 0 .132 0h3.136c.463 0 .937.033 1.39-.085a2.76 2.76 0 001.804-1.535c.188-.417.25-.86.25-1.312V8.729H15.983c-.205 0-.41.004-.613.037z",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.165 8.737c-.291.019-.58.086-.849.2a2.75 2.75 0 00-1.38 1.316c-.19.387-.287.818-.289 1.252V15.136a2.675 2.675 0 01.263-.204c.445-.303.963-.473 1.484-.573a7.598 7.598 0 011.285-.126c.424-.008.849.007 1.27.054a12.201 12.201 0 011.435.252c.028.006.134.015.149.037.01.016 0 .078 0 .096v1.077a7.675 7.675 0 00-.181-.091 5.224 5.224 0 00-1.448-.473c-.676-.11-1.44-.107-2.024.31-.564.403-.761 1.117-.7 1.796.06.662.414 1.228 1.01 1.493.59.26 1.274.226 1.892.1.507-.104.99-.293 1.45-.53v1.076c0 .018.012.08 0 .097-.014.021-.121.03-.148.036a11.58 11.58 0 01-1.613.27c-.424.04-.851.047-1.276.03a7.004 7.004 0 01-1.293-.16c-.559-.127-1.115-.346-1.555-.735v6.321c0 .013-.008.068 0 .078.018.023.17.004.205.004H23.612c.389 0 .784.021 1.172-.007a2.674 2.674 0 001.833-.943c.444-.525.664-1.19.664-1.882V8.731h-3.617l-.242-.001c-.086 0-.172.001-.258.007z",
    fill: "url(#jcb_paint2_linear)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 8,
    width: 8,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.165 8.737c-.291.019-.58.086-.849.2a2.75 2.75 0 00-1.38 1.316c-.19.387-.287.818-.289 1.252V15.136a2.675 2.675 0 01.263-.204c.445-.303.963-.473 1.484-.573a7.598 7.598 0 011.285-.126c.424-.008.849.007 1.27.054a12.201 12.201 0 011.435.252c.028.006.134.015.149.037.01.016 0 .078 0 .096v1.077a7.675 7.675 0 00-.181-.091 5.224 5.224 0 00-1.448-.473c-.676-.11-1.44-.107-2.024.31-.564.403-.761 1.117-.7 1.796.06.662.414 1.228 1.01 1.493.59.26 1.274.226 1.892.1.507-.104.99-.293 1.45-.53v1.076c0 .018.012.08 0 .097-.014.021-.121.03-.148.036a11.58 11.58 0 01-1.613.27c-.424.04-.851.047-1.276.03a7.004 7.004 0 01-1.293-.16c-.559-.127-1.115-.346-1.555-.735v6.321c0 .013-.008.068 0 .078.018.023.17.004.205.004H23.612c.389 0 .784.021 1.172-.007a2.674 2.674 0 001.833-.943c.444-.525.664-1.19.664-1.882V8.731h-3.617l-.242-.001c-.086 0-.172.001-.258.007z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_paint0_linear",
    x1: 34.833,
    y1: 8.006,
    x2: 28.421,
    y2: 8.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43C311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_paint1_linear",
    x1: 13.108,
    y1: 25.498,
    x2: 19.889,
    y2: 25.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21469E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E81EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_paint2_linear",
    x1: 27.281,
    y1: 8.73,
    x2: 20.644,
    y2: 8.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.a068770c8d0a4a57c7457a74bac94173.svg";
export { ForwardRef as ReactComponent };